// extracted by mini-css-extract-plugin
module.exports = {"info":"Hints_info__3ALnh","more":"Hints_more__S8bp0"};